import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Kullanıcının destek taleplerini getir
export const getSupportRequests = createAsyncThunk(
  "support/getSupportRequests",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_URL}/support`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Yeni destek talebi oluştur
export const createSupportRequest = createAsyncThunk(
  "support/createSupportRequest",
  async (requestData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_URL}/support`,
        requestData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const supportSlice = createSlice({
  name: "support",
  initialState: { supportRequests: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupportRequests.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSupportRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.supportRequests = action.payload;
      })
      .addCase(getSupportRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createSupportRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSupportRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.supportRequests.push(action.payload);
      })
      .addCase(createSupportRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default supportSlice.reducer;
